// GENERATED LOCALLY from products_export_1.csv - no live store data.
window.PLANNER_DATA = {
 "panels": [
  {
   "sku": "30-P-2416 GV",
   "base": "30-P-2416",
   "title": "Limited Stock - 24in Tall x 16in Wide Custom Pegboard Panel - Metal Pegboard",
   "handle": "limited-stock-24in-tall-x-16in-wide-custom-pegboard-panel-metal-pegboard",
   "color": "Metallic",
   "price": 3999,
   "cols": 1,
   "height": 24,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/24_x_16_Black_Pegboard_2_ft_Custom_Metal_Pegboard_Wall_Storage_Organizer__14159.jpg?v=1776027221",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-2416 B",
   "base": "30-P-2416",
   "title": "Limited Stock - 24in Tall x 16in Wide Custom Pegboard Panel - Metal Pegboard",
   "handle": "limited-stock-24in-tall-x-16in-wide-custom-pegboard-panel-metal-pegboard",
   "color": "Black",
   "price": 3999,
   "cols": 1,
   "height": 24,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/24_x_16_Black_Pegboard_2_ft_Custom_Metal_Pegboard_Wall_Storage_Organizer__14159.jpg?v=1776027221",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-2416 W",
   "base": "30-P-2416",
   "title": "Limited Stock - 24in Tall x 16in Wide Custom Pegboard Panel - Metal Pegboard",
   "handle": "limited-stock-24in-tall-x-16in-wide-custom-pegboard-panel-metal-pegboard",
   "color": "White",
   "price": 3999,
   "cols": 1,
   "height": 24,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/24_x_16_Black_Pegboard_2_ft_Custom_Metal_Pegboard_Wall_Storage_Organizer__14159.jpg?v=1776027221",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-2416 R",
   "base": "30-P-2416",
   "title": "Limited Stock - 24in Tall x 16in Wide Custom Pegboard Panel - Metal Pegboard",
   "handle": "limited-stock-24in-tall-x-16in-wide-custom-pegboard-panel-metal-pegboard",
   "color": "Red",
   "price": 3999,
   "cols": 1,
   "height": 24,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/24_x_16_Black_Pegboard_2_ft_Custom_Metal_Pegboard_Wall_Storage_Organizer__14159.jpg?v=1776027221",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-2416 BU",
   "base": "30-P-2416",
   "title": "Limited Stock - 24in Tall x 16in Wide Custom Pegboard Panel - Metal Pegboard",
   "handle": "limited-stock-24in-tall-x-16in-wide-custom-pegboard-panel-metal-pegboard",
   "color": "Blue",
   "price": 3999,
   "cols": 1,
   "height": 24,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/24_x_16_Black_Pegboard_2_ft_Custom_Metal_Pegboard_Wall_Storage_Organizer__14159.jpg?v=1776027221",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-2416 OR",
   "base": "30-P-2416",
   "title": "Limited Stock - 24in Tall x 16in Wide Custom Pegboard Panel - Metal Pegboard",
   "handle": "limited-stock-24in-tall-x-16in-wide-custom-pegboard-panel-metal-pegboard",
   "color": "Orange",
   "price": 3999,
   "cols": 1,
   "height": 24,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/24_x_16_Black_Pegboard_2_ft_Custom_Metal_Pegboard_Wall_Storage_Organizer__14159.jpg?v=1776027221",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-2416 G",
   "base": "30-P-2416",
   "title": "Limited Stock - 24in Tall x 16in Wide Custom Pegboard Panel - Metal Pegboard",
   "handle": "limited-stock-24in-tall-x-16in-wide-custom-pegboard-panel-metal-pegboard",
   "color": "Gray",
   "price": 3999,
   "cols": 1,
   "height": 24,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/24_x_16_Black_Pegboard_2_ft_Custom_Metal_Pegboard_Wall_Storage_Organizer__14159.jpg?v=1776027221",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-4832 GV",
   "base": "30-P-4832",
   "title": "Limited Stock - 48in Custom Pegboard Pack - Two 48in Tall x 16in Wide Pegboard Toolboards - 4 Foot Pegboard",
   "handle": "limited-stock-48in-custom-pegboard-pack-two-48in-tall-x-16in-wide-pegboard-toolboards-4-foot-pegboard",
   "color": "Metallic",
   "price": 10999,
   "cols": 2,
   "height": 48,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_48_inch_x_16_inch_metal_pegboard_double_panel_value_pack__70470.jpg?v=1776027386",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-4832 B",
   "base": "30-P-4832",
   "title": "Limited Stock - 48in Custom Pegboard Pack - Two 48in Tall x 16in Wide Pegboard Toolboards - 4 Foot Pegboard",
   "handle": "limited-stock-48in-custom-pegboard-pack-two-48in-tall-x-16in-wide-pegboard-toolboards-4-foot-pegboard",
   "color": "Black",
   "price": 11999,
   "cols": 2,
   "height": 48,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_48_inch_x_16_inch_metal_pegboard_double_panel_value_pack__70470.jpg?v=1776027386",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 GV",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Metallic",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 B",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Black",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 GN",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Green",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 OR",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Orange",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 BU",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Blue",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 W",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "White",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 R",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Red",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 G",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Gray",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 BE",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Beige",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 Y",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Yellow",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 PP",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Purple",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-HP-1632 PI",
   "base": "30-HP-1632",
   "title": "16in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "16in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Pink",
   "price": 2999,
   "cols": 2,
   "height": 16,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/white_horizontal_metal_peg_board__98737.jpg?v=1776027175",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-GP-0832 GV",
   "base": "30-GP-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Metallic",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 B",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Black",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 BE",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Beige",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 Y",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Yellow",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 BU",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Blue",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 GN",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Green",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 OR",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Orange",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 G",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Gray",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 R",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Red",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 W",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "White",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 PP",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Purple",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-0832 PI",
   "base": "30-P-0832",
   "title": "8in x 32in Horizontal Metal Pegboard Tool Board Panel",
   "handle": "8in-x-32in-horizontal-metal-pegboard-tool-board-panel",
   "color": "Pink",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Narrow_Runner_Pegboard_Wall_Control_Black_Tool_Board_Panel__84221.jpg?v=1776027160",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "SS-P-3216 SB",
   "base": "SS-P-3216",
   "title": "Signature Series Textured Matte Metal Pegboard Panel - Vertical 32in x 16in",
   "handle": "signature-series-textured-matte-metal-pegboard-panel-vertical-32in-x-16in",
   "color": "Stealth Black",
   "price": 3999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/WoodpeckersToolonWallControlMetalPegboardToolStorage.jpg?v=1779979114",
   "signature": true,
   "slotted": false
  },
  {
   "sku": "SS-P-3216 DS-1",
   "base": "SS-P-3216",
   "title": "Signature Series Textured Matte Metal Pegboard Panel - Vertical 32in x 16in",
   "handle": "signature-series-textured-matte-metal-pegboard-panel-vertical-32in-x-16in",
   "color": "Desert Sand",
   "price": 3999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/WoodpeckersToolonWallControlMetalPegboardToolStorage.jpg?v=1779979114",
   "signature": true,
   "slotted": false
  },
  {
   "sku": "SS-P-3216 HW",
   "base": "SS-P-3216",
   "title": "Signature Series Textured Matte Metal Pegboard Panel - Vertical 32in x 16in",
   "handle": "signature-series-textured-matte-metal-pegboard-panel-vertical-32in-x-16in",
   "color": "Ghost White",
   "price": 3999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/WoodpeckersToolonWallControlMetalPegboardToolStorage.jpg?v=1779979114",
   "signature": true,
   "slotted": false
  },
  {
   "sku": "SS-P-3216 GM",
   "base": "SS-P-3216",
   "title": "Signature Series Textured Matte Metal Pegboard Panel - Vertical 32in x 16in",
   "handle": "signature-series-textured-matte-metal-pegboard-panel-vertical-32in-x-16in",
   "color": "Gun Metal Grey",
   "price": 3999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/WoodpeckersToolonWallControlMetalPegboardToolStorage.jpg?v=1779979114",
   "signature": true,
   "slotted": false
  },
  {
   "sku": "30-GP-1216 GV",
   "base": "30-GP-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Metallic",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 B",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Black",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 BE",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Beige",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 PP",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Purple",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 PI",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Pink",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 G",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Gray",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 W",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "White",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 Y",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Yellow",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 OR",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Orange",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 GN",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Green",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 R",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Red",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-1216 BU",
   "base": "30-P-1216",
   "title": "12in x 16in Metal Pegboard Tile Fun Size Tool Board Panel",
   "handle": "12in-x-16in-metal-pegboard-tile-fun-size-tool-board-panel",
   "color": "Blue",
   "price": 1599,
   "cols": 1,
   "height": 12,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Fun_Sized_Small_Metal_Pegboard.jpg?v=1779197563",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-4816 GV",
   "base": "30-P-4816",
   "title": "Limited Stock - Single 48in Custom Pegboard Panel - 48in Tall x 16in Wide Galvanized Pegboard",
   "handle": "limited-stock-single-48in-custom-pegboard-panel-48in-tall-x-16in-wide-pegboard",
   "color": "Metallic",
   "price": 5999,
   "cols": 1,
   "height": 48,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/4_Feet_Wall_Control_4_Foot_Pegboard_Sheet_Metal_Pegboard_Tool_Board__55488.jpg?v=1776027266",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-4816 B",
   "base": "30-P-4816",
   "title": "Limited Stock - Single 48in Custom Pegboard Panel - 48in Tall x 16in Wide Galvanized Pegboard",
   "handle": "limited-stock-single-48in-custom-pegboard-panel-48in-tall-x-16in-wide-pegboard",
   "color": "Black",
   "price": 6999,
   "cols": 1,
   "height": 48,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/4_Feet_Wall_Control_4_Foot_Pegboard_Sheet_Metal_Pegboard_Tool_Board__55488.jpg?v=1776027266",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 GV",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Metallic",
   "price": 4999,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 B",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Black",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 GN",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Green",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 Y",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Yellow",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 OR",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Orange",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 BU",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Blue",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 R",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Red",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 G",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Gray",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 W",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "White",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "LE-30-P-3232 GLD",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Gold",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 BE",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Beige",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 PP",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Purple",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3232 PI",
   "base": "30-P-3232",
   "title": "Metal Pegboard Pack - Two 32in x 16in Pegboard Tool Boards",
   "handle": "metal-pegboard-pack-two-32in-x-16in-pegboard-tool-boards",
   "color": "Pink",
   "price": 5499,
   "cols": 2,
   "height": 32,
   "pack": 2,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Pegboard_Kit_Black_Metal_Wall_Pegboard_Panels_e59dd828-dc1d-41cb-9764-c10ecee67fc8.jpg?v=1779217590",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-GP-3216 GV",
   "base": "30-GP-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Metallic",
   "price": 2897,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 B",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Black",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 BU",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Blue",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 Y",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Yellow",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 GN",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Green",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 OR",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Orange",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 G",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Gray",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 R",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Red",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 W",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "White",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 BE",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Beige",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "LE-30-P-3216 GLD",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Gold",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 PP",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Purple",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "30-P-3216 PI",
   "base": "30-P-3216",
   "title": "32in x 16in Metal Pegboard Tool Board Panel",
   "handle": "32in-x-16in-metal-pegboard-tool-board-panel",
   "color": "Pink",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/black_wall_control_metal_pegboard__55821_83dbd49f-48ab-4d64-8e6f-ab56403fddf4.jpg?v=1776027144",
   "signature": false,
   "slotted": false
  },
  {
   "sku": "10-P-3216 B",
   "base": "10-P-3216",
   "title": "Slotted Only Wall Storage Panel 32in Tall x 16in Wide",
   "handle": "slotted-only-wall-storage-panel-32in-tall-x-16in-wide",
   "color": "Black",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-3216_Slotted_Wall_Control_Panel__34878.jpg?v=1776027208",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-3216 BU",
   "base": "10-P-3216",
   "title": "Slotted Only Wall Storage Panel 32in Tall x 16in Wide",
   "handle": "slotted-only-wall-storage-panel-32in-tall-x-16in-wide",
   "color": "Blue",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-3216_Slotted_Wall_Control_Panel__34878.jpg?v=1776027208",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-3216 G",
   "base": "10-P-3216",
   "title": "Slotted Only Wall Storage Panel 32in Tall x 16in Wide",
   "handle": "slotted-only-wall-storage-panel-32in-tall-x-16in-wide",
   "color": "Gray",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-3216_Slotted_Wall_Control_Panel__34878.jpg?v=1776027208",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-3216 OR",
   "base": "10-P-3216",
   "title": "Slotted Only Wall Storage Panel 32in Tall x 16in Wide",
   "handle": "slotted-only-wall-storage-panel-32in-tall-x-16in-wide",
   "color": "Orange",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-3216_Slotted_Wall_Control_Panel__34878.jpg?v=1776027208",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-3216 R",
   "base": "10-P-3216",
   "title": "Slotted Only Wall Storage Panel 32in Tall x 16in Wide",
   "handle": "slotted-only-wall-storage-panel-32in-tall-x-16in-wide",
   "color": "Red",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-3216_Slotted_Wall_Control_Panel__34878.jpg?v=1776027208",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-3216 Y",
   "base": "10-P-3216",
   "title": "Slotted Only Wall Storage Panel 32in Tall x 16in Wide",
   "handle": "slotted-only-wall-storage-panel-32in-tall-x-16in-wide",
   "color": "Yellow",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-3216_Slotted_Wall_Control_Panel__34878.jpg?v=1776027208",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-3216 W",
   "base": "10-P-3216",
   "title": "Slotted Only Wall Storage Panel 32in Tall x 16in Wide",
   "handle": "slotted-only-wall-storage-panel-32in-tall-x-16in-wide",
   "color": "White",
   "price": 2999,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-3216_Slotted_Wall_Control_Panel__34878.jpg?v=1776027208",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-0832 B",
   "base": "10-P-0832",
   "title": "Slotted Only Wall Storage Panel 8in Tall x 32in Wide",
   "handle": "slotted-only-wall-storage-panel-8in-tall-x-32in-wide",
   "color": "Black",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-0832_Wall_Control_Slotted_Horizontal_Wall_Panel__06914.jpg?v=1776027206",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-0832 W",
   "base": "10-P-0832",
   "title": "Slotted Only Wall Storage Panel 8in Tall x 32in Wide",
   "handle": "slotted-only-wall-storage-panel-8in-tall-x-32in-wide",
   "color": "White",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-0832_Wall_Control_Slotted_Horizontal_Wall_Panel__06914.jpg?v=1776027206",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-0832 R",
   "base": "10-P-0832",
   "title": "Slotted Only Wall Storage Panel 8in Tall x 32in Wide",
   "handle": "slotted-only-wall-storage-panel-8in-tall-x-32in-wide",
   "color": "Red",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-0832_Wall_Control_Slotted_Horizontal_Wall_Panel__06914.jpg?v=1776027206",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-0832 BU",
   "base": "10-P-0832",
   "title": "Slotted Only Wall Storage Panel 8in Tall x 32in Wide",
   "handle": "slotted-only-wall-storage-panel-8in-tall-x-32in-wide",
   "color": "Blue",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-0832_Wall_Control_Slotted_Horizontal_Wall_Panel__06914.jpg?v=1776027206",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-0832 Y",
   "base": "10-P-0832",
   "title": "Slotted Only Wall Storage Panel 8in Tall x 32in Wide",
   "handle": "slotted-only-wall-storage-panel-8in-tall-x-32in-wide",
   "color": "Yellow",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-0832_Wall_Control_Slotted_Horizontal_Wall_Panel__06914.jpg?v=1776027206",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-0832 G",
   "base": "10-P-0832",
   "title": "Slotted Only Wall Storage Panel 8in Tall x 32in Wide",
   "handle": "slotted-only-wall-storage-panel-8in-tall-x-32in-wide",
   "color": "Gray",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-0832_Wall_Control_Slotted_Horizontal_Wall_Panel__06914.jpg?v=1776027206",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-P-0832 OR",
   "base": "10-P-0832",
   "title": "Slotted Only Wall Storage Panel 8in Tall x 32in Wide",
   "handle": "slotted-only-wall-storage-panel-8in-tall-x-32in-wide",
   "color": "Orange",
   "price": 1999,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-0832_Wall_Control_Slotted_Horizontal_Wall_Panel__06914.jpg?v=1776027206",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-GP-3216 GV",
   "base": "10-GP-3216",
   "title": "Slotted Only Galvanized ToolBoard Wall Panel 32in Tall x 16in Wide - Metallic",
   "handle": "slotted-only-galvanized-toolboard-wall-panel-32in-tall-x-16in-wide-metallic",
   "color": "Metallic",
   "price": 2899,
   "cols": 1,
   "height": 32,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Galvanized_Slotted_Wall_Storage_Panell__20117.jpg?v=1776027205",
   "signature": false,
   "slotted": true
  },
  {
   "sku": "10-GP-0832 GV",
   "base": "10-GP-0832",
   "title": "Slotted Only Galvanized ToolBoard Wall Panel 8in Tall x 32in Wide - Metallic",
   "handle": "slotted-only-galvanized-toolboard-wall-panel-8in-tall-x-32in-wide-metallic",
   "color": "Metallic",
   "price": 1899,
   "cols": 2,
   "height": 8,
   "pack": 1,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-P-0832_Galvanized_Slotted_Metal_Pegboard_Panel_by_Wall_Control__28506.jpg?v=1776027203",
   "signature": false,
   "slotted": true
  }
 ],
 "kits": [
  {
   "handle": "galvanized-metallic-pegboard-8in-x-32in-basic-horizontal-starter-kit",
   "title": "Metallic Pegboard Tool Rack Horizontal Pegboard Tool Organizer Kit - Galvanized Pegboard with Accessories",
   "width": 32,
   "height": 8,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-WRR-100_GVB_Horizontal_Galvanized_Steel_Pegboard_Metal_Peg_Board_Rack_Panel__20063.jpg?v=1776027197",
   "accessories": 9,
   "bom": [
    {
     "qty": 1,
     "item": "Slotted Pegboard Screwdriver Holder Assembly"
    },
    {
     "qty": 1,
     "item": "Hammer Holder"
    },
    {
     "qty": 2,
     "item": "U-Hooks, 3in Reach"
    },
    {
     "qty": 1,
     "item": "C-Bracket, 2in x 2in"
    },
    {
     "qty": 4,
     "item": "Assorted Hooks"
    }
   ],
   "panels": [
    {
     "qty": 1,
     "w": 32,
     "h": 8,
     "item": "Galvanized Narrow Pegboard Horizontal Panel 8in Tall x 32in Wide",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-WRR-100 GVB",
     "price": 3999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Accessory Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRR-100 GVW",
     "price": 3999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Accessory Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRR-100 GVR",
     "price": 3999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Accessory Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRR-100 GVBU",
     "price": 3999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Accessory Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "basic-laundry-room-organizer-kit-white-wall-panels-and-white-accessories",
   "title": "Basic Pegboard Laundry Room Organizer Kit",
   "width": 32,
   "height": 8,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Pegboard_Tool_Board_Laundry_Room_Organizer__77010.jpg?v=1776027138",
   "accessories": 4,
   "bom": [
    {
     "qty": 1,
     "item": "Hanger Holder with 4in Shelf"
    },
    {
     "qty": 2,
     "item": "U-Hooks with 3in Reach"
    },
    {
     "qty": 1,
     "item": "Handle Holder Brackets"
    }
   ],
   "panels": [
    {
     "qty": 1,
     "w": 32,
     "h": 8,
     "item": "Narrow Pegboard Runner Panel 8in x 32in",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-LAU-100 BB",
     "price": 4499,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 WW",
     "price": 4499,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 RR",
     "price": 4499,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 BUBU",
     "price": 4499,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GVW",
     "price": 4499,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Galv / White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GVBU",
     "price": 4499,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Galv / Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GVR",
     "price": 4499,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Galv / Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GVB",
     "price": 4499,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Galv / Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 BBU",
     "price": 4499,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Black / Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 BR",
     "price": 4499,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Black / Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 WB",
     "price": 4499,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "White / Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 WBU",
     "price": 4499,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "White / Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 WR",
     "price": 4499,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "White / Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 RW",
     "price": 4499,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Red / White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 RB",
     "price": 4499,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Red / Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 RBU",
     "price": 4499,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Red / Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 BUW",
     "price": 4499,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Blue / White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 BUB",
     "price": 4499,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Blue / Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 BUR",
     "price": 4499,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Blue / Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GW",
     "price": 4499,
     "pegboardColor": "Gray",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Gray / White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GB",
     "price": 4499,
     "pegboardColor": "Gray",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Gray / Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GBU",
     "price": 4499,
     "pegboardColor": "Gray",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Gray / Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GR",
     "price": 4499,
     "pegboardColor": "Gray",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Gray / Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GNW",
     "price": 4499,
     "pegboardColor": "Green",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Green / White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GNB",
     "price": 4499,
     "pegboardColor": "Green",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Green / Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GNR",
     "price": 4497,
     "pegboardColor": "Green",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Green / Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 GNBU",
     "price": 4497,
     "pegboardColor": "Green",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Green / Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 ORW",
     "price": 4497,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Orange / White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 ORB",
     "price": 4497,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Orange / Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 ORBU",
     "price": 4497,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Orange / Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 ORR",
     "price": 4497,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Orange / Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 YW",
     "price": 4497,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Yellow / White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 YB",
     "price": 4497,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Yellow / Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 YBU",
     "price": 4497,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Yellow / Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 YR",
     "price": 4497,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Yellow / Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-LAU-100 BW",
     "price": 4497,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color and Accessory Color",
      "value": "Black / White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "garage-storage-lawn-garden-tool-organization-wall-organizer-rack-pegboard-with-accessories",
   "title": "Garage Storage Lawn & Garden Tool Organization Wall Organizer Rack - Pegboard with Accessories",
   "width": 64,
   "height": 8,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-GWS-0864_BEB_Wall_Control_Tan_Cream_Peg_Board_Garage_Storage_Lawn_and_Garden_Wall_Rack_Organizer_Beige_Metal_Pegboard__62251.jpg?v=1776027320",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 2,
     "w": 32,
     "h": 8,
     "item": "two of Wall Control's 8-Inch Tall x 32-Inch Wide Metal Pegboards",
     "source": "prose"
    }
   ],
   "variants": [
    {
     "sku": "30-GWS-0864 GVBU",
     "price": 7999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 GVB",
     "price": 7999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 GVW",
     "price": 7999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 GVR",
     "price": 7999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 BBU",
     "price": 7999,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 BB",
     "price": 7999,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 BW",
     "price": 7999,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 BR",
     "price": 7999,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 WBU",
     "price": 7999,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 WB",
     "price": 7999,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 WW",
     "price": 7999,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 WR",
     "price": 7999,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 RBU",
     "price": 7999,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 RB",
     "price": 7999,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 RW",
     "price": 7999,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 RR",
     "price": 7999,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 BUBU",
     "price": 7999,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 BUB",
     "price": 7999,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 BUW",
     "price": 7999,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 BUR",
     "price": 7999,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 GBU",
     "price": 7999,
     "pegboardColor": "Grey",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Grey"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 GB",
     "price": 7999,
     "pegboardColor": "Grey",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Grey"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 GW",
     "price": 7999,
     "pegboardColor": "Grey",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Grey"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 GR",
     "price": 7999,
     "pegboardColor": "Grey",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Grey"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 PIBU",
     "price": 7999,
     "pegboardColor": "Pink",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 PIB",
     "price": 7999,
     "pegboardColor": "Pink",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 PIW",
     "price": 7999,
     "pegboardColor": "Pink",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 PIR",
     "price": 7999,
     "pegboardColor": "Pink",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 PPBU",
     "price": 7999,
     "pegboardColor": "Purple",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 PPB",
     "price": 7999,
     "pegboardColor": "Purple",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 PPW",
     "price": 7999,
     "pegboardColor": "Purple",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 PPR",
     "price": 7999,
     "pegboardColor": "Purple",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 YBU",
     "price": 7999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 YB",
     "price": 7999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 YW",
     "price": 7999,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 YR",
     "price": 7999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 ORBU",
     "price": 7999,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 ORB",
     "price": 7999,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 ORW",
     "price": 7999,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 ORR",
     "price": 7999,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 GNBU",
     "price": 7999,
     "pegboardColor": "Green",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 GNB",
     "price": 7999,
     "pegboardColor": "Green",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 GNW",
     "price": 7999,
     "pegboardColor": "Green",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 GNR",
     "price": 7999,
     "pegboardColor": "Green",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GWS-0864 BEBU",
     "price": 7999,
     "pegboardColor": "Beige",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GWS-0864 BEB",
     "price": 7999,
     "pegboardColor": "Beige",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GWS-0864 BEW",
     "price": 7999,
     "pegboardColor": "Beige",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GWS-0864 BER",
     "price": 7999,
     "pegboardColor": "Beige",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    }
   ]
  },
  {
   "handle": "wall-organizer-great-for-jewelry-or-tool-wall-storage-wall-mounted-orange-slotted-only-organizer-panel-with-hooks",
   "title": "Wall Organizer Great for Jewelry or Tool Wall Storage - Wall Mounted Slotted Only Organizer Panel with Hooks",
   "width": 16,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30_JWL_100_WW_Jewelry_Organizer_Wall_Jewelry_Hanging_Kit_Wall_Control__25808.jpg?v=1776027241",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 1,
     "w": 16,
     "h": 32,
     "item": "Slotted-only Jewelry Panel",
     "source": "reviewed",
     "interchangeable": false
    }
   ],
   "variants": [
    {
     "sku": "10-JWL-100 YB",
     "price": 3999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-JWL-100 YW",
     "price": 3999,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-JWL-100 YR",
     "price": 3999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-JWL-100 YBU",
     "price": 3999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "10-JWL-100 RB",
     "price": 3999,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-JWL-100 RW",
     "price": 3999,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-JWL-100 RR",
     "price": 3999,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-JWL-100 RBU",
     "price": 3999,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "10-JWL-100 BUB",
     "price": 3999,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-JWL-100 BUW",
     "price": 3999,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-JWL-100 BUR",
     "price": 3999,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-JWL-100 BUBU",
     "price": 3999,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "10-JWL-100 GB",
     "price": 3999,
     "pegboardColor": "Gray",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-JWL-100 GW",
     "price": 3999,
     "pegboardColor": "Gray",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-JWL-100 GR",
     "price": 3999,
     "pegboardColor": "Gray",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-JWL-100 GBU",
     "price": 3999,
     "pegboardColor": "Gray",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "10-JWL-100 BB",
     "price": 3999,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-JWL-100 BW",
     "price": 3999,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-JWL-100 BR",
     "price": 3999,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-JWL-100 BBU",
     "price": 3999,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "10-JWL-100 WB",
     "price": 3999,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-JWL-100 WW",
     "price": 3999,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-JWL-100 WR",
     "price": 3999,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-JWL-100 WBU",
     "price": 3999,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "10-JWL-100 ORB",
     "price": 3999,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-JWL-100 ORW",
     "price": 3999,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-JWL-100 ORR",
     "price": 3999,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-JWL-100 ORBU",
     "price": 3999,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    }
   ]
  },
  {
   "handle": "basic-metal-pegboard-utility-tool-storage-kit-metallic-pegboard-black-hooks",
   "title": "Metal Pegboard Essentials Utility Tool Storage Kit - Metallic Pegboard with Accessories",
   "width": 16,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-WGL-100_GVB_Wall_Control_Galvanized_Pegboard_Shiny_Steel_Pegboard_Panel_Utility_Kit__64859.jpg?v=1776027195",
   "accessories": 11,
   "bom": [
    {
     "qty": 1,
     "item": "6in Deep x16in Wide Shelf Assembly w/Shelf brackets"
    },
    {
     "qty": 1,
     "item": "14in Wide Bin Hanger & (3) Plastic Bins"
    },
    {
     "qty": 1,
     "item": "Screwdriver Holder Assembly"
    },
    {
     "qty": 1,
     "item": "Hammer Holder Bracket"
    },
    {
     "qty": 7,
     "item": "Assorted Hooks and Brackets"
    }
   ],
   "panels": [
    {
     "qty": 1,
     "w": 16,
     "h": 32,
     "item": "Wall Mounted Galvanized Steel Pegboard Tool Board 16in x 32in",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-WGL-100 GVB",
     "price": 4999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Accessory Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-100 GVW",
     "price": 4999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Accessory Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-100 GVR",
     "price": 4999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Accessory Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-100 GVBU",
     "price": 4999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Accessory Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "pegboard-garden-tool-board-organizer-kit-pegboard-with-accessories",
   "title": "Pegboard Garden Tool Board Organizer Kit - Pegboard with Accessories",
   "width": 16,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/71ns5JAwESL._SL1397___58798__31347.jpg?v=1776027142",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 1,
     "w": 16,
     "h": 32,
     "item": "Vertical Metal Pegboard",
     "source": "reviewed"
    },
    {
     "qty": 2,
     "w": 32,
     "h": 8,
     "item": "Pegboard Runner Strip",
     "source": "reviewed"
    }
   ],
   "variants": [
    {
     "sku": "30-GRD-200 GVBU",
     "price": 9999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 GVB",
     "price": 9999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 GVR",
     "price": 9999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 GVW",
     "price": 9999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GRD-200 BBU",
     "price": 9999,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 BB",
     "price": 9999,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 BR",
     "price": 9999,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 BW",
     "price": 9999,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GRD-200 WBU",
     "price": 9999,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 WB",
     "price": 9999,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 WR",
     "price": 9999,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 WW",
     "price": 9999,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GRD-200 RBU",
     "price": 9999,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 RB",
     "price": 9999,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 RR",
     "price": 9999,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 RW",
     "price": 9999,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GRD-200 BUBU",
     "price": 9999,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 BUB",
     "price": 9999,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 BUR",
     "price": 9999,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 BUW",
     "price": 9999,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GRD-200 ORBU",
     "price": 9999,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 ORB",
     "price": 9999,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 ORR",
     "price": 9999,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 ORW",
     "price": 9999,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GRD-200 GNBU",
     "price": 9999,
     "pegboardColor": "Green",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 GNB",
     "price": 9999,
     "pegboardColor": "Green",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 GNR",
     "price": 9999,
     "pegboardColor": "Green",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 GNW",
     "price": 9999,
     "pegboardColor": "Green",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GRD-200 GBU",
     "price": 9999,
     "pegboardColor": "Gray",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 GB",
     "price": 9999,
     "pegboardColor": "Gray",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 GR",
     "price": 9999,
     "pegboardColor": "Gray",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 GW",
     "price": 9999,
     "pegboardColor": "Gray",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-GRD-200 YBU",
     "price": 9999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-GRD-200 YB",
     "price": 9999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-GRD-200 YR",
     "price": 9999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-GRD-200 YW",
     "price": 9999,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    }
   ]
  },
  {
   "handle": "standard-laundry-room-organizer-kit-white-wall-panels-and-white-accessories",
   "title": "Standard Laundry Room Organizer Kit - White Wall Panels with Accessories",
   "width": 16,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10_LAU_200_WW_A_Standard_Laundry_Room_Organizer_Tool_Board_White_Panels__37050__90404.jpg?v=1776027137",
   "accessories": 7,
   "bom": [
    {
     "qty": 1,
     "item": "9in x 16in Laundry Room Shelf Assembly with Shelf Dividers"
    },
    {
     "qty": 1,
     "item": "4in x 16in Laundry Room Shelf Assembly with Dowel Rod"
    },
    {
     "qty": 2,
     "item": "Slotted U-Hooks, 3in Reach"
    },
    {
     "qty": 2,
     "item": "Laundry Room Handle Hangers, 1-1/4in"
    },
    {
     "qty": 1,
     "item": "Pack of General Purpose Hooks for hanging and organizing laundry room supplies"
    }
   ],
   "panels": [
    {
     "qty": 1,
     "w": 16,
     "h": 32,
     "item": "Slotted Storage Wall Panel 32in x 16in",
     "source": "bom"
    },
    {
     "qty": 1,
     "w": 32,
     "h": 8,
     "item": "Slotted Storage Wall Panel 8in x 32in",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "10-LAU-200 WB",
     "price": 9497,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Accessory Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "10-LAU-200 WW",
     "price": 9497,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Accessory Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "10-LAU-200 WR",
     "price": 9497,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Accessory Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "10-LAU-200 WBU",
     "price": 9497,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Accessory Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "pegboard-paint-supplies-organizer-kit-metallic-toolboard-black-accessories",
   "title": "Pegboard Paint Supplies Organizer Kit - Metallic Toolboard & Black Accessories",
   "width": 16,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-PST-100_GVB_Pegboard_Paint_Supply_Storage_Kit__95534.jpg?v=1776027071",
   "accessories": 9,
   "bom": [
    {
     "qty": 1,
     "item": "9 Inch Shelf Assembly"
    },
    {
     "qty": 1,
     "item": "Spray Can Holder Assembly"
    },
    {
     "qty": 1,
     "item": "Rolling Pan Hanger with Roller Bin"
    },
    {
     "qty": 2,
     "item": "Roller Hanging Hooks with 9 Inch Reach"
    },
    {
     "qty": 4,
     "item": "Wall Control Medium Length Paint Brush Hooks"
    }
   ],
   "panels": [
    {
     "qty": 1,
     "w": 16,
     "h": 32,
     "item": "Galvanized Combo Pegboard Panel 32 Inch Tall x 16 Inch Wide",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-PST-100 GVB",
     "price": 6999,
     "pegboardColor": "Metallic",
     "accessoryColor": null,
     "option1": {
      "name": "Title",
      "value": "Default Title"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "kitchen-pegboard-organizer-kit-pots-pans-rack-pegboard-with-hooks",
   "title": "Kitchen Pegboard Organizer Kit Pots & Pans Rack - Pegboard With Hooks",
   "width": 32,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/wall-control-gold-metal-pegboard-pot-and-pan-storage-wall__95507.jpg?v=1776027458",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 2,
     "w": 16,
     "h": 32,
     "item": "two 16in x 32in powder-coated metal panels",
     "source": "prose"
    }
   ],
   "variants": [
    {
     "sku": "30-KTH-200 GVW",
     "price": 6999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 GVR",
     "price": 6999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 GVBU",
     "price": 6999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 GVB",
     "price": 6999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 BW",
     "price": 6999,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 BR",
     "price": 6999,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 BBU",
     "price": 6999,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 BB",
     "price": 6999,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 WW",
     "price": 6999,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 WR",
     "price": 6999,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 WBU",
     "price": 6999,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 WB",
     "price": 6999,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 RW",
     "price": 6999,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 RR",
     "price": 6999,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 RBU",
     "price": 6999,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 RB",
     "price": 6999,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 BUW",
     "price": 6999,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 BUR",
     "price": 6999,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 BUBU",
     "price": 6999,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 BUB",
     "price": 6999,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 GNW",
     "price": 6999,
     "pegboardColor": "Green",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 GNR",
     "price": 6999,
     "pegboardColor": "Green",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 GNBU",
     "price": 6999,
     "pegboardColor": "Green",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 GNB",
     "price": 6999,
     "pegboardColor": "Green",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 ORW",
     "price": 6999,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 ORR",
     "price": 6999,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 ORBU",
     "price": 6999,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 ORB",
     "price": 6999,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 YW",
     "price": 6999,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 YR",
     "price": 6999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 YBU",
     "price": 6999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 YB",
     "price": 6999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 GW",
     "price": 6999,
     "pegboardColor": "Gray",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 GR",
     "price": 6999,
     "pegboardColor": "Gray",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 GBU",
     "price": 6999,
     "pegboardColor": "Gray",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 GB",
     "price": 6999,
     "pegboardColor": "Gray",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 BEW",
     "price": 6999,
     "pegboardColor": "Beige",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 BER",
     "price": 6999,
     "pegboardColor": "Beige",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 BEBU",
     "price": 6999,
     "pegboardColor": "Beige",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 BEB",
     "price": 6999,
     "pegboardColor": "Beige",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "LE-30-KTH-200 GLDW",
     "price": 6999,
     "pegboardColor": "Gold",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "LE-30-KTH-200 GLDR",
     "price": 6999,
     "pegboardColor": "Gold",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "LE-30-KTH-200 GLDBU",
     "price": 6999,
     "pegboardColor": "Gold",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "LE-30-KTH-200 GLDB",
     "price": 6999,
     "pegboardColor": "Gold",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 PIW",
     "price": 6999,
     "pegboardColor": "Pink",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 PIR",
     "price": 6999,
     "pegboardColor": "Pink",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 PIBU",
     "price": 6999,
     "pegboardColor": "Pink",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 PIB",
     "price": 6999,
     "pegboardColor": "Pink",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-KTH-200 PPW",
     "price": 6999,
     "pegboardColor": "Purple",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-KTH-200 PPR",
     "price": 6999,
     "pegboardColor": "Purple",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-KTH-200 PPBU",
     "price": 6999,
     "pegboardColor": "Purple",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-KTH-200 PPB",
     "price": 6999,
     "pegboardColor": "Purple",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    }
   ]
  },
  {
   "handle": "craft-hobby-pegboard-organizer-kit-pegboard-with-accessories",
   "title": "Craft & Hobby Pegboard Organizer Kit - Pegboard With Accessories",
   "width": 32,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/wall-control-gold-metal-pegboard-craft-organization-kit-white-accessories__36585.jpg?v=1776027456",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 2,
     "w": 16,
     "h": 32,
     "item": "two 16in x 32in powder-coated metal pegboard",
     "source": "prose"
    }
   ],
   "variants": [
    {
     "sku": "30-CC-200 GVB",
     "price": 12999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 GVW",
     "price": 12999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 GVR",
     "price": 12999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 GVBU",
     "price": 12999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-CC-200 BB",
     "price": 12999,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 BW",
     "price": 12999,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 BR",
     "price": 12999,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 BBU",
     "price": 12999,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-CC-200 WB",
     "price": 12999,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 WW",
     "price": 12999,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 WR",
     "price": 12999,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 WBU",
     "price": 12999,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-CC-200 RB",
     "price": 12999,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 RW",
     "price": 12999,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 RR",
     "price": 12999,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 RBU",
     "price": 12999,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-CC-200 BUB",
     "price": 12999,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 BUW",
     "price": 12999,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 BUR",
     "price": 12999,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 BUBU",
     "price": 12999,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-CC-200 YB",
     "price": 12999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 YW",
     "price": 12999,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 YR",
     "price": 12999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 YBU",
     "price": 12999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-CC-200 ORB",
     "price": 12999,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 ORW",
     "price": 12999,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 ORR",
     "price": 12999,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 ORBU",
     "price": 12999,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-CC-200 GNB",
     "price": 12999,
     "pegboardColor": "Green",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 GNW",
     "price": 12999,
     "pegboardColor": "Green",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 GNR",
     "price": 12999,
     "pegboardColor": "Green",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 GNBU",
     "price": 12999,
     "pegboardColor": "Green",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-CC-200 GB",
     "price": 12999,
     "pegboardColor": "Gray",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-CC-200 GW",
     "price": 12999,
     "pegboardColor": "Gray",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-CC-200 GR",
     "price": 12999,
     "pegboardColor": "Gray",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-CC-200 GBU",
     "price": 12999,
     "pegboardColor": "Gray",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "LE-30-CC-200 GLDB",
     "price": 12999,
     "pegboardColor": "Gold",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "LE-30-CC-200 GLDW",
     "price": 12999,
     "pegboardColor": "Gold",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "LE-30-CC-200 GLDR",
     "price": 12999,
     "pegboardColor": "Gold",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "LE-30-CC-200 GLDBU",
     "price": 12999,
     "pegboardColor": "Gold",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    }
   ]
  },
  {
   "handle": "lazy-guy-diy-maker-woodworking-tool-storage-organizer-set-metal-pegboard-with-accessories",
   "title": "Lazy Guy DIY Maker Woodworking Tool Storage Organizer Set - Metal Pegboard with Accessories",
   "width": 32,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/hunter_green_metal_pegboard_woodworking_kit_with_white_accessories_and_tools_lazy_guy_diy_woodworking_tool_storage_set_for_makers_influencers__80257.jpg?v=1776027355",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 2,
     "w": 16,
     "h": 32,
     "item": "Vertical Metal Pegboard",
     "source": "reviewed"
    },
    {
     "qty": 1,
     "w": 32,
     "h": 8,
     "item": "Narrow Horizontal Pegboard Rack",
     "source": "reviewed"
    }
   ],
   "variants": [
    {
     "sku": "30-DIY-3264 GVW",
     "price": 15999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 GVR",
     "price": 15999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 GVBU",
     "price": 15999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 GVB",
     "price": 15999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 BW",
     "price": 15999,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 BR",
     "price": 15999,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 BBU",
     "price": 15999,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 BB",
     "price": 15999,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 WW",
     "price": 15999,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 WR",
     "price": 15999,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 WBU",
     "price": 15999,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 WB",
     "price": 15999,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 RW",
     "price": 15999,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 RR",
     "price": 15999,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 RBU",
     "price": 15999,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 RB",
     "price": 15999,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 BUW",
     "price": 15999,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 BUR",
     "price": 15999,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 BUBU",
     "price": 15999,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 BUB",
     "price": 15999,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 BEW",
     "price": 15999,
     "pegboardColor": "Beige",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 BER",
     "price": 15999,
     "pegboardColor": "Beige",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 BEBU",
     "price": 15999,
     "pegboardColor": "Beige",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 BEB",
     "price": 15999,
     "pegboardColor": "Beige",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 YW",
     "price": 15999,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 YR",
     "price": 15999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 YBU",
     "price": 15999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 YB",
     "price": 15999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 PPW",
     "price": 15999,
     "pegboardColor": "Purple",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 PPR",
     "price": 15999,
     "pegboardColor": "Purple",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 PPBU",
     "price": 15999,
     "pegboardColor": "Purple",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 PPB",
     "price": 15999,
     "pegboardColor": "Purple",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 ORW",
     "price": 15999,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 ORR",
     "price": 15999,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 ORBU",
     "price": 15999,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 ORB",
     "price": 15999,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 PIW",
     "price": 15999,
     "pegboardColor": "Pink",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 PIR",
     "price": 15999,
     "pegboardColor": "Pink",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 PIBU",
     "price": 15999,
     "pegboardColor": "Pink",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 PIB",
     "price": 15999,
     "pegboardColor": "Pink",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 GW",
     "price": 15999,
     "pegboardColor": "Grey",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Grey"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 GR",
     "price": 15999,
     "pegboardColor": "Grey",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Grey"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 GBU",
     "price": 15999,
     "pegboardColor": "Grey",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Grey"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 GB",
     "price": 15999,
     "pegboardColor": "Grey",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Grey"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-DIY-3264 GNW",
     "price": 15999,
     "pegboardColor": "Green",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-DIY-3264 GNR",
     "price": 15999,
     "pegboardColor": "Green",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-DIY-3264 GNBU",
     "price": 15999,
     "pegboardColor": "Green",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-DIY-3264 GNB",
     "price": 15999,
     "pegboardColor": "Green",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    }
   ]
  },
  {
   "handle": "metal-pegboard-utility-tool-storage-kit-metallic-pegboard-black-accessories",
   "title": "Metal Pegboard Utility Tool Storage Kit - Metallic Pegboard with Accessories",
   "width": 32,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-WGL-200_GVR_Utility_Steel_Pegboard_Tool_Board_Red__73860.jpg?v=1776027068",
   "accessories": 21,
   "bom": [
    {
     "qty": 1,
     "item": "6in Shelf Assembly"
    },
    {
     "qty": 3,
     "item": "Plastic Bins with Bin Hangers"
    },
    {
     "qty": 1,
     "item": "Screwdriver Holder"
    },
    {
     "qty": 1,
     "item": "Hammer Holder"
    },
    {
     "qty": 15,
     "item": "Assorted Hooks and Brackets"
    }
   ],
   "panels": [
    {
     "qty": 2,
     "w": 16,
     "h": 32,
     "item": "Galvanized Metal Pegboard Panels 32in x 16in (Covers 32in x 32in when Installed)",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-WGL-200 GVB",
     "price": 8999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Accessory Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-200 GVW",
     "price": 8999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Accessory Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-200 GVR",
     "price": 8999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Accessory Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-200 GVBU",
     "price": 8999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Accessory Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "metal-pegboard-tool-organizer-starter-kit-metallic-pegboard-black-hooks",
   "title": "Metal Pegboard Tool Organizer Starter Kit - Metallic Pegboard with Hooks",
   "width": 32,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-WGL-210_GVB_Steel_Pegboard_Starter_Kit_Organizer__46032.jpg?v=1776027066",
   "accessories": 20,
   "bom": [
    {
     "qty": 12,
     "item": "Standard Hooks, 3/4 Reach"
    },
    {
     "qty": 4,
     "item": "Medium Hooks, 1-7/8 in. Reach"
    },
    {
     "qty": 2,
     "item": "Long Hooks, 6 in. Reach"
    },
    {
     "qty": 2,
     "item": "U-Hooks, 3 in. Reach"
    }
   ],
   "panels": [
    {
     "qty": 2,
     "w": 16,
     "h": 32,
     "item": "Galvanized Metal Pegboard Panels 32in x 16in (Covers 32in x 32in when installed)",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-WGL-210 GVB",
     "price": 5999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Accessory Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-210 GVW",
     "price": 5999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Accessory Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-210 GVR",
     "price": 5999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Accessory Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WGL-210 GVBU",
     "price": 5999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Accessory Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "deluxe-laundry-room-organizer-kit-white-wall-panels-and-white-accessories",
   "title": "Deluxe Laundry Room Organizer Kit - White Wall Panels and White Accessories",
   "width": 32,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10-LDX-300_Wall_Control_Laundry_Room_Storage_Organizer_Wall_Mounted_Kit__52020.jpg?v=1776026694",
   "accessories": 10,
   "bom": [
    {
     "qty": 2,
     "item": "9in Shelf Assembly with Shelf Dividers"
    },
    {
     "qty": 1,
     "item": "6in Shelf Assembly"
    },
    {
     "qty": 1,
     "item": "4in Shelf / Dowel Rod Assembly"
    },
    {
     "qty": 1,
     "item": "Tip-Out Bin Organizer"
    },
    {
     "qty": 2,
     "item": "U-Hooks, 3in Reach"
    },
    {
     "qty": 2,
     "item": "Handle Hangers, 1-1/4in"
    },
    {
     "qty": 1,
     "item": "Pack of Assorted Hooks and Brackets"
    }
   ],
   "panels": [
    {
     "qty": 2,
     "w": 16,
     "h": 32,
     "item": "Slotted Storage Panel 32in x 16in, White Finish",
     "source": "bom"
    },
    {
     "qty": 1,
     "w": 32,
     "h": 8,
     "item": "Slotted Storage Runner Panel 8in x 32in",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "10-LDX-300 WW",
     "price": 19999,
     "pegboardColor": "White",
     "accessoryColor": null,
     "option1": {
      "name": "Title",
      "value": "Default Title"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "metal-pegboard-utility-tool-storage-kit-black-pegboard-with-hooks",
   "title": "Wall Control Premium Steel Pegboard Kit - Black Pegboard with Hooks",
   "width": 32,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/WallControlHeroKit.jpg?v=1773434007",
   "accessories": 1,
   "bom": [
    {
     "qty": 1,
     "item": "16\" x 6\" All-Purpose Metal Shelf"
    }
   ],
   "panels": [
    {
     "qty": 2,
     "w": 16,
     "h": 32,
     "item": "Powder-Coated Steel Pegboard Panel",
     "source": "reviewed"
    }
   ],
   "variants": [
    {
     "sku": "30-RTL-F100BB",
     "price": 9999,
     "pegboardColor": "Black",
     "accessoryColor": null,
     "option1": {
      "name": "Title",
      "value": "Default Title"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "4ft-patriot-pegboard-standard-tool-storage-kit-red-white-blue",
   "title": "4ft Patriot Pegboard Premium Tool Storage Kit - Red White & Blue",
   "width": 48,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/71wEKTesWtL._SL1271___85547__32353.jpg?v=1776027134",
   "accessories": 27,
   "bom": [
    {
     "qty": 1,
     "item": "9in Shelf Assembly"
    },
    {
     "qty": 1,
     "item": "6in Shelf Assembly"
    },
    {
     "qty": 3,
     "item": "Plastic Hanging Bins with Bin Hanger"
    },
    {
     "qty": 1,
     "item": "Screwdriver Holder"
    },
    {
     "qty": 1,
     "item": "Hammer Holder"
    },
    {
     "qty": 20,
     "item": "Additional Hooks and Brackets"
    }
   ],
   "panels": [
    {
     "qty": 3,
     "w": 16,
     "h": 32,
     "item": "Powder-Coated Metal Pegboard Panels 32in x 16in",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "S30-WRK-400 RWBU",
     "price": 17760,
     "pegboardColor": null,
     "accessoryColor": null,
     "option1": {
      "name": "Title",
      "value": "Default Title"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "4ft-metal-pegboard-standard-tool-storage-kit-toolboard-with-hooks",
   "title": "4ft Metal Pegboard Premium Tool Storage Kit - Toolboard with Hooks",
   "width": 48,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-WRK-400_BB_Pegboard_Hooks_Wall_Control_Pegboard_Standard_Workbench_Tool_Board_Kit_Black_Pegboard_Black_Peg_Hooks__16308.jpg?v=1776027079",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 3,
     "w": 16,
     "h": 32,
     "item": "Three 16in x 32in powder-coated pegboard",
     "source": "prose"
    }
   ],
   "variants": [
    {
     "sku": "30-WRK-400 GVB",
     "price": 14397,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 GVW",
     "price": 14999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 GVR",
     "price": 14999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 GVBU",
     "price": 14999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 BB",
     "price": 14497,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 BW",
     "price": 14999,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 BR",
     "price": 14999,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 BBU",
     "price": 14999,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 WB",
     "price": 14999,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 WW",
     "price": 14999,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 WR",
     "price": 14999,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 WBU",
     "price": 14999,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 RB",
     "price": 14999,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 RW",
     "price": 14999,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 RR",
     "price": 14999,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 RBU",
     "price": 14999,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 BUB",
     "price": 14999,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 BUW",
     "price": 14999,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 BUR",
     "price": 14999,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 BUBU",
     "price": 14999,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 GNB",
     "price": 14999,
     "pegboardColor": "Green",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 GNW",
     "price": 14999,
     "pegboardColor": "Green",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 GNR",
     "price": 14999,
     "pegboardColor": "Green",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 GNBU",
     "price": 14999,
     "pegboardColor": "Green",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 ORB",
     "price": 14999,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 ORW",
     "price": 14999,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 ORR",
     "price": 14999,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 ORBU",
     "price": 14999,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 YB",
     "price": 14999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 YW",
     "price": 14999,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 YR",
     "price": 14999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 YBU",
     "price": 14999,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 GB",
     "price": 14999,
     "pegboardColor": "Gray",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 GW",
     "price": 14999,
     "pegboardColor": "Gray",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 GR",
     "price": 14999,
     "pegboardColor": "Gray",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 GBU",
     "price": 14999,
     "pegboardColor": "Gray",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 BEB",
     "price": 14397,
     "pegboardColor": "Beige",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 BEW",
     "price": 14397,
     "pegboardColor": "Beige",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 BER",
     "price": 14397,
     "pegboardColor": "Beige",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 BEB",
     "price": 14397,
     "pegboardColor": "Beige",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "LE-30-WRK-400 GLDW",
     "price": 14397,
     "pegboardColor": "Gold",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "LE-30-WRK-400 GLDW",
     "price": 14397,
     "pegboardColor": "Gold",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "LE-30-WRK-400 GLDR",
     "price": 14397,
     "pegboardColor": "Gold",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "LE-30-WRK-400 GLDBU",
     "price": 14397,
     "pegboardColor": "Gold",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 PIB",
     "price": 14397,
     "pegboardColor": "Pink",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 PIW",
     "price": 14397,
     "pegboardColor": "Pink",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 PIR",
     "price": 14397,
     "pegboardColor": "Pink",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 PIBU",
     "price": 14397,
     "pegboardColor": "Pink",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-400 PPB",
     "price": 14397,
     "pegboardColor": "Purple",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-400 PPW",
     "price": 14397,
     "pegboardColor": "Purple",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-400 PPR",
     "price": 14397,
     "pegboardColor": "Purple",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-400 PPBU",
     "price": 14397,
     "pegboardColor": "Purple",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    }
   ]
  },
  {
   "handle": "4-ft-metal-pegboard-basic-tool-organizer-kit-metallic-toolboard-black-hooks",
   "title": "4 ft Metal Pegboard Basic Tool Organizer Kit - Metallic Toolboard & Hooks",
   "width": 48,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-BAS-300_GVB_Basic_steel_pegboard_tool_board_organizer_Wall_Control_pegboard__92298.jpg?v=1776027070",
   "accessories": 24,
   "bom": [
    {
     "qty": 1,
     "item": "Dowel Rod and 4 in. Shelf Assembly"
    },
    {
     "qty": 1,
     "item": "Screwdriver Holder"
    },
    {
     "qty": 2,
     "item": "Hammer Holders"
    },
    {
     "qty": 2,
     "item": "U-Hooks with 3 in. Reach"
    },
    {
     "qty": 18,
     "item": "Additional Hooks and Brackets"
    }
   ],
   "panels": [
    {
     "qty": 3,
     "w": 16,
     "h": 32,
     "item": "Galvanized Metal Pegboard Panels 32 in. x 16 in. (Covers 48 in. x 32 in. when Installed)",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-BAS-300 GVB",
     "price": 12999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Accessory Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-BAS-300 GVW",
     "price": 12999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Accessory Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-BAS-300 GVR",
     "price": 12999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Accessory Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-BAS-300 GVBU",
     "price": 12999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Accessory Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "wall-mounted-home-office-wall-organizer-kit-wall-panels-with-accessories",
   "title": "Wall-Mounted Home & Office Wall Organizer Kit - Wall Panels with Accessories",
   "width": 48,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/10_OFC_300_BW_Pegboard_Office_Pegboard_Wall_Control_Pegboard_Desk_Pegboard_Office_Pegboard__08721.jpg?v=1776027041",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 3,
     "w": 16,
     "h": 32,
     "item": "Three 16in x 32in powder-coated slotted panels",
     "source": "prose"
    }
   ],
   "variants": [
    {
     "sku": "10-OFC-300 GVB",
     "price": 19999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-OFC-300 GVW",
     "price": 19999,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-OFC-300 GVR",
     "price": 19999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-OFC-300 GVBU",
     "price": 19999,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "10-OFC-300 BB",
     "price": 19999,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-OFC-300 BW",
     "price": 19999,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-OFC-300 BR",
     "price": 19999,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-OFC-300 BBU",
     "price": 19999,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "10-OFC-300 WB",
     "price": 19999,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "10-OFC-300 WW",
     "price": 19999,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "10-OFC-300 WR",
     "price": 19999,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "10-OFC-300 WBU",
     "price": 19999,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    }
   ]
  },
  {
   "handle": "ultimate-metal-pegboard-wall-organizer-kit",
   "title": "Ultimate Metal Pegboard Wall Organizer Kit",
   "width": 48,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/Wall_Control_Metal_Pegboard_Workbench_Tool_Storage_Organizer_System_Garage_Peg_Boards.png?v=1780173507",
   "accessories": null,
   "bom": [],
   "panels": [
    {
     "qty": 3,
     "w": 16,
     "h": 32,
     "item": "Vertical Metal Pegboard",
     "source": "reviewed"
    }
   ],
   "variants": [
    {
     "sku": "30-WRK-400-GVB",
     "price": 14397,
     "pegboardColor": "Metallic",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-BB",
     "price": 14497,
     "pegboardColor": "Black",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-WB",
     "price": 14999,
     "pegboardColor": "White",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-RB",
     "price": 14999,
     "pegboardColor": "Red",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-BUB",
     "price": 14999,
     "pegboardColor": "Blue",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-GB",
     "price": 14999,
     "pegboardColor": "Gray",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Gray"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-YB",
     "price": 14999,
     "pegboardColor": "Yellow",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-GNB",
     "price": 14999,
     "pegboardColor": "Green",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Green"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-ORB",
     "price": 14999,
     "pegboardColor": "Orange",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Orange"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-PIB",
     "price": 14999,
     "pegboardColor": "Pink",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Pink"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-PPB",
     "price": 14999,
     "pegboardColor": "Purple",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Purple"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-WRK-400-BEB",
     "price": 14999,
     "pegboardColor": "Beige",
     "accessoryColor": null,
     "option1": {
      "name": "Color",
      "value": "Beige"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "pro-grade-metal-pegboard-organizer-galvanized-pegboards-with-black-accessories",
   "title": "Pro-Grade Pegboard Organizer Kit - Galvanized Pegboard with Accessories",
   "width": 64,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-COS-400_GVB_Pro-Grade_Professional_Pegboard_Galvanized_Steel_Metal_Pegboard__86297.jpg?v=1776027199",
   "accessories": 27,
   "bom": [
    {
     "qty": 1,
     "item": "6in Deep x 16in Wide Tool Board Shelf Assembly"
    },
    {
     "qty": 1,
     "item": "4in Deep x16in Wide Tool Board Shelf & 16in Wide Dowel Rod Assembly"
    },
    {
     "qty": 1,
     "item": "Screwdriver Holder Assembly"
    },
    {
     "qty": 12,
     "item": "Standard Tool Board Hook"
    },
    {
     "qty": 4,
     "item": "Medium Tool Board Hook"
    },
    {
     "qty": 2,
     "item": "Tool Board Handle Hanger, 1-1/4in"
    },
    {
     "qty": 2,
     "item": "Tool Board U-Hook 3in Reach"
    },
    {
     "qty": 2,
     "item": "Tool Board C-Bracket, 1inx1in"
    },
    {
     "qty": 2,
     "item": "Tool Board C-Bracket, 2inx2in"
    }
   ],
   "panels": [
    {
     "qty": 4,
     "w": 16,
     "h": 32,
     "item": "32in Tall x16in Wide Galvanized Steel Pegboard Panel",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-COS-400 GVB",
     "price": 16497,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Accessory Color",
      "value": "Black"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-COS-400 GVW",
     "price": 16497,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Accessory Color",
      "value": "White"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-COS-400 GVR",
     "price": 16497,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Accessory Color",
      "value": "Red"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    },
    {
     "sku": "30-COS-400 GVBU",
     "price": 16497,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Accessory Color",
      "value": "Blue"
     },
     "option2": {
      "name": "",
      "value": ""
     }
    }
   ]
  },
  {
   "handle": "8ft-metal-pegboard-master-workbench-kit-blue-toolboard-white-accessories",
   "title": "8ft Metal Pegboard Master Workbench Kit - Assorted Pegboard & Accessory Colors",
   "width": 96,
   "height": 32,
   "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/30-WRK-800-WB-garage-wall-tool-storage-metal-pegboard-organization-system-white.jpg?v=1780172617",
   "accessories": 47,
   "bom": [
    {
     "qty": 1,
     "item": "9in Shelf Assembly"
    },
    {
     "qty": 2,
     "item": "9in Shelf Dividers"
    },
    {
     "qty": 1,
     "item": "6in Shelf Assembly"
    },
    {
     "qty": 15,
     "item": "Plastic Hanging Garage Storage Bins with Hangers"
    },
    {
     "qty": 1,
     "item": "Dowel Rod and 4in Shelf Assembly"
    },
    {
     "qty": 1,
     "item": "Spray Can Holder (Holds 4 Cans)"
    },
    {
     "qty": 2,
     "item": "Screwdriver Holders (Holds 6 Each)"
    },
    {
     "qty": 2,
     "item": "Hammer Holders"
    },
    {
     "qty": 22,
     "item": "Additional Hooks and Brackets"
    }
   ],
   "panels": [
    {
     "qty": 6,
     "w": 16,
     "h": 32,
     "item": "Powder-Coated Metal Pegboards 32in x 16in (Covers 96in x 32in Installed)",
     "source": "bom"
    }
   ],
   "variants": [
    {
     "sku": "30-WRK-800 GVB",
     "price": 28597,
     "pegboardColor": "Metallic",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 GVW",
     "price": 28597,
     "pegboardColor": "Metallic",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 GVR",
     "price": 28597,
     "pegboardColor": "Metallic",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 GVBU",
     "price": 28597,
     "pegboardColor": "Metallic",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Metallic"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 BB",
     "price": 29997,
     "pegboardColor": "Black",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 BW",
     "price": 29997,
     "pegboardColor": "Black",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 BR",
     "price": 29997,
     "pegboardColor": "Black",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 BBU",
     "price": 29997,
     "pegboardColor": "Black",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Black"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 WB",
     "price": 29997,
     "pegboardColor": "White",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 WW",
     "price": 29997,
     "pegboardColor": "White",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 WR",
     "price": 29997,
     "pegboardColor": "White",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 WBU",
     "price": 29997,
     "pegboardColor": "White",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "White"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 RB",
     "price": 29997,
     "pegboardColor": "Red",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 RW",
     "price": 29997,
     "pegboardColor": "Red",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 RR",
     "price": 29997,
     "pegboardColor": "Red",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 RBU",
     "price": 29997,
     "pegboardColor": "Red",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Red"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 BUB",
     "price": 29997,
     "pegboardColor": "Blue",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 BUW",
     "price": 29997,
     "pegboardColor": "Blue",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 BUR",
     "price": 29997,
     "pegboardColor": "Blue",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 BUBU",
     "price": 29997,
     "pegboardColor": "Blue",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Blue"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 GNB",
     "price": 29997,
     "pegboardColor": "Green",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 GNW",
     "price": 29997,
     "pegboardColor": "Green",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 GNR",
     "price": 29997,
     "pegboardColor": "Green",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 GNBU",
     "price": 29997,
     "pegboardColor": "Green",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Green"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 ORB",
     "price": 29997,
     "pegboardColor": "Orange",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 ORW",
     "price": 29997,
     "pegboardColor": "Orange",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 ORR",
     "price": 29997,
     "pegboardColor": "Orange",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 ORBU",
     "price": 29997,
     "pegboardColor": "Orange",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Orange"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 YB",
     "price": 29997,
     "pegboardColor": "Yellow",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 YW",
     "price": 29997,
     "pegboardColor": "Yellow",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 YR",
     "price": 29997,
     "pegboardColor": "Yellow",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 YBU",
     "price": 29997,
     "pegboardColor": "Yellow",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Yellow"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 GB",
     "price": 29997,
     "pegboardColor": "Gray",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 GW",
     "price": 29997,
     "pegboardColor": "Gray",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 GR",
     "price": 29997,
     "pegboardColor": "Gray",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 GBU",
     "price": 29997,
     "pegboardColor": "Gray",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gray"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 BEB",
     "price": 29997,
     "pegboardColor": "Beige",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 BEW",
     "price": 29997,
     "pegboardColor": "Beige",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 BER",
     "price": 29997,
     "pegboardColor": "Beige",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 BEBU",
     "price": 29997,
     "pegboardColor": "Beige",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Beige"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "LE-30-WRK-800 GLDB",
     "price": 29997,
     "pegboardColor": "Gold",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "LE-30-WRK-800 GLDW",
     "price": 29997,
     "pegboardColor": "Gold",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "LE-30-WRK-800 GLDR",
     "price": 29997,
     "pegboardColor": "Gold",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "LE-30-WRK-800 GLDBU",
     "price": 29997,
     "pegboardColor": "Gold",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Gold"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 PIB",
     "price": 29997,
     "pegboardColor": "Pink",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 PIW",
     "price": 29997,
     "pegboardColor": "Pink",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 PIR",
     "price": 29997,
     "pegboardColor": "Pink",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 PIBU",
     "price": 29997,
     "pegboardColor": "Pink",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Pink"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    },
    {
     "sku": "30-WRK-800 PPB",
     "price": 29997,
     "pegboardColor": "Purple",
     "accessoryColor": "Black",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Black"
     }
    },
    {
     "sku": "30-WRK-800 PPW",
     "price": 29997,
     "pegboardColor": "Purple",
     "accessoryColor": "White",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "White"
     }
    },
    {
     "sku": "30-WRK-800 PPR",
     "price": 29997,
     "pegboardColor": "Purple",
     "accessoryColor": "Red",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Red"
     }
    },
    {
     "sku": "30-WRK-800 PPBU",
     "price": 29997,
     "pegboardColor": "Purple",
     "accessoryColor": "Blue",
     "option1": {
      "name": "Pegboard Color",
      "value": "Purple"
     },
     "option2": {
      "name": "Accessory Color",
      "value": "Blue"
     }
    }
   ]
  }
 ],
 "vbracket": {
  "handle": "3d-v-bracket-metal-pegboard-space-optimizer",
  "title": "3D V-Bracket Metal Pegboard Space Optimizer",
  "image": "https://cdn.shopify.com/s/files/1/0648/9840/0299/files/3D_Pegboard_Wall_Bracket_Storage_Organizer_3_Dimensional__94254.jpg?v=1770908212",
  "heights": {
   "32": {
    "White": {
     "sku": "ASM-3DVB-32 W",
     "price": 3999
    },
    "Red": {
     "sku": "ASM-3DVB-32 R",
     "price": 3999
    },
    "Blue": {
     "sku": "ASM-3DVB-32 BU",
     "price": 3999
    },
    "Black": {
     "sku": "ASM-3DVB-32 B",
     "price": 3999
    }
   },
   "24": {
    "White": {
     "sku": "ASM-3DVB-24 W",
     "price": 3999
    },
    "Red": {
     "sku": "ASM-3DVB-24 R",
     "price": 3999
    },
    "Blue": {
     "sku": "ASM-3DVB-24 BU",
     "price": 3999
    },
    "Black": {
     "sku": "ASM-3DVB-24 B",
     "price": 3999
    }
   },
   "12": {
    "White": {
     "sku": "ASM-3DVB-12 W",
     "price": 3999
    },
    "Red": {
     "sku": "ASM-3DVB-12 R",
     "price": 3999
    },
    "Blue": {
     "sku": "ASM-3DVB-12 BU",
     "price": 3999
    },
    "Black": {
     "sku": "ASM-3DVB-12 B",
     "price": 3999
    }
   }
  },
  "width": 16,
  "depth": 15.0625
 }
};
